import axios from "axios";
import { API_URL } from "@/config";

export default {
  namespaced: true,

  actions: {
    async create(_, kitchenMealReleaseData) {
      const response = await axios.post(`${API_URL}/kitchensMealsReleases`, kitchenMealReleaseData);

      if (!response.data || typeof response.data.id !== "number") {
        throw new Error("Error occurred while processing your request.");
      }

      return response.data;
    },

    async markAsReleasedForTransport(_, kitchenMealReleaseData) {
      const response = await axios.post(
        `${API_URL}/kitchensMealsReleases/markAsReleasedForTransport`,
        kitchenMealReleaseData,
      );

      if (response.status !== 200 || !response.data.status) {
        throw new Error("Error occurred while processing your request.");
      }

      return response.data;
    },

    async markAsNotReleasedForTransport(_, kitchenMealReleaseData) {
      const response = await axios.post(
        `${API_URL}/kitchensMealsReleases/markAsNotReleasedForTransport`,
        kitchenMealReleaseData,
      );

      if (response.status !== 200 || !response.data.status) {
        throw new Error("Error occurred while processing your request.");
      }

      return response.data;
    },

    async delete(_, kitchenMealReleaseData) {
      const response = await axios.delete(`${API_URL}/kitchensMealsReleases`, {
        params: kitchenMealReleaseData,
      });

      if (response.status !== 200 || !response.data.status) {
        throw new Error("Error occurred while processing your request.");
      }

      return true;
    },
  },
};
